import React from "react";
import{List, Datagrid, TextField,ImageField,ImageInput,DateInput, EditButton, Edit, SimpleForm, TextInput, Create, SelectInput, NumberField, NumberInput  } from 'react-admin';
import { useState } from 'react';
import { useSelector } from "react-redux";
import {   
  useNotify,
  useRedirect
} from 'react-admin';
import { Button, Box } from '@mui/material';
import ImageSelectorModal from './imageSelectorModal';
import PublicationTab from "./PublicationTab";

const REACT_APP_URL_API = process.env.REACT_APP_URL_API;
// const REACT_APP_SERVER_API = process.env.REACT_APP_SERVER_API;
// const REACT_APP_PORT_API = process.env.REACT_APP_PORT_API || 3001;
// const REACT_APP_PATH_API = process.env.REACT_APP_PATH_API;
// const REACT_APP_PATH_API_COURSE=process.env.REACT_APP_PATH_API_COURSE;

// const BASE_COURSE_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_COURSE}`;


export const CourseList =(props)=>(
    <List{...props}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="title" title="title" label="Título"/>
            <ImageField source="image" title ="title" label="Imagen"/>
            <TextField source="program" title="title" label="Programa"/>
            <TextField source="level" title="title" label="Nivel"/>
            <TextField source="description" title="title" label="Descripción" />
            <NumberField source="price" title="title" label="Precio" />
            <EditButton/>
            <PublicationTab/>
        </Datagrid>
    </List>
);

export const CourseCreate =(props)=>{
const [imageUrl,setImageUrl]= useState ('');
  const [modalOpen, setModalOpen]= useState(false);
  const notify = useNotify();
  const redirect= useRedirect();
  const credentials = useSelector(state => state.credentials);
  const token = credentials.token || localStorage.getItem('token') || null;

  const handleSubmit = async (values) => {
    try {
      const payload = { ...values, image: imageUrl };
      const response = await fetch(`${REACT_APP_URL_API}/course/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization' : `Bearer ${token}` },
        credentials: 'include',
        body: JSON.stringify(payload)
      });

      const result =await response.json();
      console.log('Response:', result);
      if (response.ok) {
        notify('Curso creado con éxito');
        redirect('/admin/courses');
      } else {
        notify(result.message ||'Error al crear el curso', { type: 'error' });
      }
    } catch (error) {
      console.error(error);
      notify('Error de red', { type: 'error' });
    }
  };

  return(
    <>
    <Create {...props}>
      <SimpleForm onSubmit={handleSubmit}>
          <TextInput source="title"  label= "Titulo"fullWidth />
          <TextInput source="description" label= "Descripcion" multiline fullWidth />
          <TextInput source="program" label= "Programa" multiline fullWidth />
          <NumberInput source="price" label= "Precio" />
          <Box display="flex" gap={2}>
              <SelectInput source="level"  label= "Nivel"choices={[
            { id: 'Basico', name: 'Básico' },
            { id: 'Intermedio', name: 'Intermedio' },
            { id: 'Avanzado', name: 'Avanzado' }
          ]} />
          <SelectInput source="status" label ="Estado" choices={[
            { id: 'Activo', name: 'Activo' },
            { id: 'Inactivo', name: 'Inactivo' }
          ]} defaultValue="Activo" />
          </Box>
        
          <Box display="flex" gap={2}>
              <DateInput 
              source="startDate" 
              label='fecha de inicio'
              fullWidth={false}
              sx={{ flex: 1 }} 
              
              />
              <DateInput 
              source="endDate" 
              label='fecha de fin'
              fullWidth={false}
              sx={{ flex: 1 }}/>      
          </Box>
        
           <Box mt={2}>
            <Button variant="contained" onClick={() => setModalOpen(true)}>
              Seleccionar Imagen
            </Button>
            {imageUrl && (
              <Box mt={1}>
                <img src={imageUrl} alt="Seleccionada" width="200" />
              </Box>
            )}
          </Box>
      </SimpleForm>
    </Create>
     <ImageSelectorModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSelect={(url) => setImageUrl(url)}
      />
    </>
  )

}

  
